import { Component, SimpleChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import {UnitConversionUtils} from '../../configurator/unit-conversion-utils';
import {SureFlowUnitData} from '../../model/sure-flow-unit-data';
import {CoilRequest} from '../../model/coil-request';
import {SureFlowRatingUnitRequest} from '../../model/sure-flow-rating-unit-request';
import {GuruEntity} from '../../model/guru-entity';
import { SureFlowPerformanceCoilInputComponent } from '../sure-flow-performance-coil-input/sure-flow-performance-coil-input.component';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-sure-flow-performance-input',
    templateUrl: './sure-flow-performance-input.component.html',
    styleUrls: ['./sure-flow-performance-input.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, SureFlowPerformanceCoilInputComponent]
})
export class SureFlowPerformanceInputComponent {

  readonly requestInput = input.required<SureFlowRatingUnitRequest>({ alias: 'request' });
  readonly unitData = input.required<SureFlowUnitData>();
  readonly selectionChange = output<GuruEntity | undefined>();
  metricInput!: string;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.metricInput = this.requestInput().metric ? 'True' : 'False';
  }

  localInputChanged(entityName: string, value: string) {
    const entity: GuruEntity = new GuruEntity();
    entity.Name = entityName;
    entity.Value = value;
    this.selectionChange.emit(entity);
  }

  inputChanged(entity: GuruEntity | undefined): void {
    this.selectionChange.emit(entity);
  }

  getEspUnits(): string {
    return UnitConversionUtils.getEspUnits(this.requestInput().metric);
  }

  getAirflowUnits(): string {
    return UnitConversionUtils.getAirflowUnits(this.requestInput().metric);
  }

  getLengthUnits(): string {
    return UnitConversionUtils.getLengthUnits(this.requestInput().metric);
  }

  getExpectedTotalCapacity(request: CoilRequest): number {
    if (request.isCooling) {
      return this.unitData().coolingTargetTotalLoad;
    } else if (!request.isElectricHeat) {
      return this.unitData().heatingTargetTotalLoad;
    }
    return undefined!;
  }

}
